import React, { useEffect, useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import App from '../app';
import { fetchDummyOrderData, fetchOrderDataForTrackingPage } from '../actions/tracking';

export function TrackingPageApp(props) {
  const { trackingPageId, orderId, zipCode, fetchTracking, fetchDummyTracking, initialized, status } = props;

  useEffect(() => {
    fetchTrackingData();
  }, []);

  const { shopId, isSettingsLoaded } = props;

  useEffect(() => {
    if (isSettingsLoaded && window.heap) {
      window.heap.addEventProperties({ shopId });
      window.heap.track('View tracking page', { shopId });
    }
  }, [shopId, isSettingsLoaded]);

  const fetchTrackingData = useCallback(
    (language) => {
      if (isDummyOrderId(orderId)) {
        fetchDummyTracking && fetchDummyTracking(trackingPageId, language);
      } else {
        fetchTracking && fetchTracking(trackingPageId, orderId, zipCode, language);
      }
    },
    [orderId, fetchTracking, fetchDummyTracking]
  );

  const isDummy = isDummyOrderId(orderId);

  if (!isDummy && initialized && status !== 'published') {
    return null;
  }

  return <App isDummy={isDummy} onChangeLanguage={fetchTrackingData} />;
}

TrackingPageApp.propTypes = {
  trackingPageId: PropTypes.string,
  orderId: PropTypes.string,
  fetchSettings: PropTypes.func,
  fetchTracking: PropTypes.func,
  fetchDummyTracking: PropTypes.func,
  initialized: PropTypes.bool,
  status: PropTypes.string,
};

function isDummyOrderId(orderId) {
  return orderId === '<orderId>';
}

function mapStateToProps(state) {
  const {
    settings: {
      initialized,
      settings: { status, localization },
      loaded: isSettingsLoaded,
    },
  } = state;

  return {
    initialized,
    status,
    shopId: localization && localization.shopId,
    isSettingsLoaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTracking: (...args) => dispatch(fetchOrderDataForTrackingPage(...args)),
    fetchDummyTracking: (...args) => dispatch(fetchDummyOrderData(...args)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(memo(TrackingPageApp));



// WEBPACK FOOTER //
// ./src/js/containers/TrackingPageApp.js